import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.mitteilung-empfaenger';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationMitteilungEmpfaengerEffects {

    MitteilungEmpfaenger$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MITTEILUNG_EMPFAENGER),
        mergeMap((x: ac.GetMitteilungEmpfaengerAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMitteilungEmpfaenger(x.mitteilung_id).pipe(
                map((result: any) => {
                    return new ac.GetMitteilungEmpfaengerErfolgreichAction(result, x.mitteilung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMitteilungEmpfaengerFehlerAction(error, x.mitteilung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungenQueryService);
        }
        return this.service;
    }
}
